<template>
    <div class="service-section pt-100 pb-70">
        <div class="container">
           
            <div class="row">
                <div
                    class="col-md-6 col-lg-4 pb-30"
                    v-for="card in serviceCards"
                    :key="card.route"
                >
                    <div class="service-card">
                        <div class="service-card-thumb">
                            <img v-lazy="cardImage(card.image)" :alt="card.title">
                        </div>
                        <div class="service-card-body">
                            <h3>{{ card.title }}</h3>
                            <p>{{ card.description }}</p>
                            <router-link :to="card.route" class="redirect-link">
                                {{ $t('common.buttons.clickForDetails') }}
                                <i class="icofont-rounded-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <nav class="page-pagination" aria-label="Page Pagination">
                        <ul class="pagination">
                            <li class="page-item disabled">
                                <a class="page-link" href="services" tabindex="-1" aria-disabled="true">
                                    <i class="flaticon-left-chevron"></i>
                                </a>
                            </li>
                            <li class="page-item active">
                                <a class="page-link" href="services">1</a>
                            </li>
                            <!-- <li class="page-item" aria-current="page">
                                <a class="page-link" href="blogs">2</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="blogs">3</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="blogs">...</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="blogs">10</a>
                            </li> -->
                            <li class="page-item">
                                <a class="page-link" href="services">
                                    <i class="flaticon-right-chevron"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Services',
    computed: {
        serviceCards() {
            const cards = this.$t('services.cards')
            return Array.isArray(cards) ? cards : []
        }
    },
    methods: {
        cardImage(imageName) {
            if (!imageName) return ''
            return this.$ossImg(`services/${imageName}`)
        }
    }
}
</script>
<style lang="css" scoped>
.service-card-body {
    padding:  0 20px;
}
</style>
